/**
 * Main Javascript File
 */

// script dependent on jQuery
jQuery(document).ready(function () {
    // Scripts for main menu mobile
    var elMenuMainMobile = $("#wrapper-navbar .menu-main-mobile");
    var elBody = $("body");

    $(document).on("click", ".navbar-toggler", function (e) {
        elMenuMainMobile.css('display', 'flex');
        elBody.css({
            "overflow": "hidden",
            "position": "relative", // fix bug to safari iOS
        });
    })
    $(document).on("click", ".menu-main-mobile-close", function (e) {
        elMenuMainMobile.fadeOut()
        elBody.css({
            "overflow": "initial",
            "position": "initial",
        });
    })

    $(document).on("click", ".menu-main-mobile .menu-item-has-children > a", function (e) {
        e.preventDefault();
        var subMenu = $(this).siblings(".sub-menu");
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            subMenu.slideUp();
        } else {
            $(this).addClass("active");
            subMenu.slideDown();
        }
    })
    //Function to searchform tooltipe type
    $(document).on("click", ".searchform-tooltip--btn", function () {
        const form = $("#searchform-tt");
        form.toggle();
        form.find(".field").focus();
        return false;
    });

    //function for submitting the subscriber form
    $(document).on("click", ".subs-form-result-error", function () {
        $(".subs-form-result-error").toggleClass("d-none");
        $("#subs-form .form-group, #subs-form button[type=submit] ").show();
    })

    $(document).on("click", ".subs-form-captcha-error", function () {
        $(".subs-form-captcha-error").toggleClass("d-none");
        $("#subs-form .form-group, #subs-form button[type=submit] ").show();
    })



    $('#subs-form').submit(function (event) {

        //Disabling the form after submit
        $('.subs-form-sending').toggleClass('d-none');
        $('#subs-form .form-group, #subs-form button[type=submit]').hide();

        className = $('#sidebar div:eq(14)').attr('class');

        var recaptchaInstance = ($('div.g-recaptcha').length)-1;

        if ($('#theme_g_recaptcha').length){
            var recaptcha = grecaptcha.getResponse(recaptchaInstance);
        }else{
            var recaptcha = 0;
        }

        var formData = {
            'rock_convert_subscribe_email': $('#email-subscribe-form').val(),
            'rock_convert_subscribe_name': $('#rock_convert_subscribe_name').val(),
            'rock_convert_subscribe_custom_field': $('#rock_convert_subscribe_custom_field').val(),
            'rock_convert_subscribe_nonce': $('input[name=rock_convert_subscribe_nonce]').val(),
            'rock_convert_subscribe_page': $('input[name=rock_convert_subscribe_page]').val(),
            'rock_get_current_post_id': $('input[name=rock_get_current_post_id]').val(),
            'rock_convert_subscribe_redirect_page': $('input[name=rock_convert_subscribe_redirect_page]').val(),
            'g-recaptcha-response': recaptcha,
            'action': 'rock_convert_subscribe_form'
        }

        var form = $(this);
        //Acessing the XMLHttpRequest object to retrieve the URLs params
        var xhr;
        var _orgAjax = jQuery.ajaxSettings.xhr;
        jQuery.ajaxSettings.xhr = function () {
            xhr = _orgAjax();
            return xhr;
        };

        // process the form
        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: formData,
            encode: true,
            success: function () {
                $('.subs-form-sending').toggleClass('d-none');
                var url = new URL(xhr.responseURL);
                var status = url.searchParams.get("error") ? 'error' : 'success';

                if (recaptcha.length === 0) {
                    $('.subs-form-captcha-error').toggleClass('d-none');
                    $('#subs-form .form-group, #subs-form button[type=submit]').hide();
                } else {
                    if (status === 'success') {
                        $('.subs-form-result-success').toggleClass('d-none');
                        $('#subs-form .form-group, #subs-form button[type=submit]').hide();
                    } else {
                        $('.subs-form-result-error').toggleClass('d-none');
                        $('#subs-form .form-group, #subs-form button[type=submit]').hide();
                    }
                }
            }
        });

        // stop the form from submitting the normal way and refreshing the page
        event.preventDefault();
    });
});
